export default {
  clearSearch: '清除查询',
  search: '搜索',
  all: '全部',
  or: '或',
  yes: '是',
  no: '否',
  appleStore: 'Apple Store零售店',
  reward: '奖金',
  rmb: '￥',
  serverError: '系统错误，请联系管理员',
  label: {
    now: '现在',
    operate: '操作',
    sortOperate: '排序',
    yes: '是',
    no: '否',
    status: '状态',
    agreed: '已同意',
    noAgreed: '尚未同意',
    comment: '评论',
    selectAll: '全部',
    agreePolicy: '我同意',
    noData: '暂无数据',
    english: '英语',
    chinese: '中文',
    have: '有',
    notHave: '没有'
  },
  separator: {
    or: ' 或 '
  },
  date: {
    yesterday: '昨天'
  },
  btn: {
    ok: '确定',
    confirm: '确认',
    save: '保存',
    cancel: '取消',
    edit: '编辑',
    add: '添加',
    move: '移动',
    remove: '移除',
    delete: '删除',
    enable: '激活',
    disable: '禁用',
    select: '选择',
    last: '上一步',
    prev: '上一步',
    next: '下一步',
    submit: '提交',
    download: '下载',
    copy: '复制',
    back: '返回',
    expand: '展开',
    collapse: '收起',
    replace: '替换',
    clear: '清空',
    share: '分享',
    preview: '预览',
    view: '查看',
    invite: '邀请',
    send: '发送',
    placeholder: '占位符',
    export: '导出',
    search: '搜索',
    action: '操作',
    yesInvite: '确认',
    noInvite: '取消',
    apply: '申请',
    signIn: '登录',
    refresh: '刷新',
    clickToUpload: '点击上传',
    generate: '生成',
    reject: '拒绝',
    accept: '接受'
  },
  message: {
    wrongImageType: '请上传图片文件！',
    wrongImageSize: '请上传小于{size}MB的文件！',
    pcAndMobileImageRequired: '请添加手机端和电脑端图片',
    uploadError: '上传失败，请稍后再试',
    unSaveChangeConfirm: '修改尚未保存，确定放弃吗？',
    requiredFormField: '这是必填项',
    InvalidMaxLength: '长度不大于 {max} 个字符',
    invalidEmail: '邮箱地址无效',
    invalidMobile: '电话号码无效',
    invalidPwd: '密码必须包含大小写字母和数字，长度至少10位，特殊符号只能是_#@.-',
    passwordNotSame: '两次输入的密码不一致',
    needAgreePolicy: '注册之前必须同意菁客用户条款',
    needLoginAgreePolicy: '登录之前必须同意菁客用户条款',
    sendSuccess: '发送成功!',
    sendFail: '发送失败，请稍后再试!',
    saveSuccess: '保存成功!',
    saveFail: '保存失败，请稍后再试!',
    actionSuccess: '{action}成功!',
    actionFail: '{action}失败，请稍后再试!',
    actionConfirm: '确定{action}?',
    continueWithAgreePolicy: '请同意以上条款再继续',
    revokeCurrentPosition: '是否撤销当前职位？',
    revokeAllApplicationTip: '是否撤回你的数据？',
    downloadResource: {
      VIDEO_POSTER: '点击这里从浏览器中打开，下载视频海报！'
    },
    invalidIDCardNumber: '身份证号无效',
    mobileOnlySupport: '手机号仅支持数字、+、-、()',
    emptyName: '名字不能为空',
    noMatchedData: '无匹配数据',
    inviteSuccess: '邀请已经成功发送。',
    inviteFailed: '邀请发送失败',
    copyLink: '请按CTRL+C复制地址',
    submitSuccess: '提交成功',
    agreeSystemPolicyWarning: '必须同意菁客用户条款。',
    selectDisabledHmWarning: '该招聘经理账号已被禁用，请启用该账号。联系你的AJINGA管理员或者客户成功顾问获取支持。',
    confirmDelete: '确定删除？',
    refreshPageWithoutSaveData: '确定重新载入页面？系统不会保存您所做的更改。',
    inviteInterviewFail: '候选人状态为{statusName}，邀请失败，联系你的AJINGA管理员或者客户成功顾问获取支持。',
    revokeAllApplication: '请注意，当前保存代表您撤回对公司协议的同意，保存后将删除该公司下所有申请',
    logoff: '请注意，当前保存代表您撤回对平台协议的同意，保存后将注销您的账户',
    nameHasExist: '该名称已存在，请重新输入。',
    shareJobLoginFail: '登录失败，请重新在PC端生成二维码后扫一扫',
    mapLoadFail: '当前地图加载遇到问题，请尝试重新点击地图按钮。',
    optionSuccess: '操作成功！',
    invalidNumber: '请输入正确的分数数字',
    downloadSuccess: '下载成功！',
    downloadFailed: '下载失败，请稍后再试！',
    exportFailed: '导出失败，请稍后再试！',
    success: '操作成功',
    error: '操作失败',
    warning: '警告'
  },
  gender: {
    male: '男',
    female: '女',
    nonBinary: '非二元',
    preferNotToDisclose: '不愿透露'
  },
  upload: {
    tipMessage: {
      addHeaderImage: {
        pc: '添加电脑端图片',
        mobile: '添加手机端图片'
      }
    }
  },
  conditionType: {
    include: '包含',
    exclude: '不包含',
    equal: '等于',
    notEqual: '不等于'
  },
  dateShortcut: {
    today: '今天',
    yesterday: '昨天',
    lastWeek: '近一周',
    lastMonth: '近一月',
    last3Month: '近三月',
    last6Month: '近半年',
    lastYear: '去年',
    thisYear: '今年'
  }
}
